import React, { useEffect, useState, useRef } from 'react';
import loadingGif from '../assets/loading.gif';
import phoneSvg from '../assets/fi_phone.svg';
import phoneGreenSvg from '../assets/phone-green.svg';
import endCallSvg from '../assets/End_call.svg';
import { initWebphone, resetWebphone, setWebphoneHandlers } from '../services/webphoneManager';
import backendApi from '../services/backendApi';

const VoipCall = ({ data, orderId, phoneToCall }) => {
    const [callConnected, setCallConnected] = useState(false);
    const [callDisconnected, setCallDisconnected] = useState(false);
    const [time, setTime] = useState(0);
    const [statusText, setStatusText] = useState('Palaukite');
    const [statusSecondary, setStatusSecondary] = useState('Jungiamasi prie skambučio');
    const [imageSrc, setImageSrc] = useState(loadingGif);
    const [showEndCall, setShowEndCall] = useState(false);

    const timerRef = useRef(null);
    const extendIntervalRef = useRef(null);
    const storedRef = useRef(false);

    const pad = (val) => (val < 10 ? `0${val}` : val);
    const formatTime = (seconds) => `${pad(Math.floor(seconds / 60))}:${pad(seconds % 60)}`;

    const webphoneApi = initWebphone(data, phoneToCall);

    const endCall = () => {
        if (callDisconnected) return;
        setCallDisconnected(true);
        setCallConnected(false);
        webphoneApi.hangup();
        webphoneApi.unregister();
        releaseVoipCredentials();
        setShowEndCall(false);
        setImageSrc(null);
    };

    const releaseVoipCredentials = () => {
        backendApi.post('/api/release-voip-credentials', { id: data.id }, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    };

    const storeAnsweredCall = (callId, destination) => {
        if (storedRef.current) return;
        storedRef.current = true;

        const payload = {
            callId: callId.replace('[', '').replace(']', ''),
            destination,
            orderId
        };

        backendApi.post('/api/store-answered-call', payload, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    };

    useEffect(() => {
        const webphoneApi = initWebphone(data, phoneToCall);

        resetWebphone(data);

        setWebphoneHandlers({
            onRinging: () => {
                setStatusText('Palaukite');
                setStatusSecondary('Skambinama');
                setImageSrc(phoneSvg);
                setShowEndCall(true);
            },
            onCallConnect: (evtarray) => {
                storeAnsweredCall(evtarray[7], evtarray[3]);
                setStatusText('');
                setCallConnected(true);
                setImageSrc(phoneGreenSvg);

                timerRef.current = setInterval(() => {
                    setTime((prev) => prev + 1);
                }, 1000);
            },
            onCDR: (evtarray) => {
                if (evtarray[9] === 'Busy Here') {
                    setStatusText('Užimta');
                    setStatusSecondary('Vairuotojas negali atsiliepti.');
                } else {
                    setStatusText('Skambutis baigtas');
                    setStatusSecondary('');
                }
                endCall();
            }
        });

        extendIntervalRef.current = setInterval(() => {
            if (webphoneApi.isincall()) {
                backendApi.post('/api/extend_voip_reservation', { id: data.id }, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
            }
        }, 100000);

        return () => {
            clearInterval(timerRef.current);
            clearInterval(extendIntervalRef.current);
        };
    }, [data]);

    return (
        <div className="content-wrapper">
            <div className="call-data">
                {imageSrc && (
                    <img className="image-center end-call-btns" src={imageSrc} width={50} alt="status" />
                )}
                <span className="text fs-20" align="center">{statusText}</span>
                <span className="text" align="center">
                    {callConnected ? formatTime(time) : statusSecondary}
                </span>
            </div>

            {showEndCall && (
                <img
                    className="image-center end-call-btn bottom-image"
                    onClick={endCall}
                    src={endCallSvg}
                    width={50}
                    alt="End Call"
                />
            )}
        </div>
    );
};

export default VoipCall;
